var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"mb-2"},[_c('router-link',{attrs:{"to":{ name: 'Riskcomponent', params: { id: _vm.item.id }}}},[_c('h5',[_vm._v(_vm._s(_vm.item.name)+" ["+_vm._s(_vm.item.id)+"]")])]),_c('div',[_vm._v("deleted: "+_vm._s(_vm.item.del))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }